import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "app/store"

import { BookedDatesProps, CalendarInitialState } from "./types"

const initialState: CalendarInitialState = {
  error: null,
  dates: [],
  blockedDates: [],
  bookedDates: [],
  isBookingInfoDrawerOpen: false,
  bookingNumber: null,
}

export const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    reset: () => {},
    setCalendarBlockedDates: (state, action: PayloadAction<Array<string>>) => {
      state.blockedDates = action.payload
    },
    setCalendarBookedDates: (
      state,
      action: PayloadAction<BookedDatesProps>,
    ) => {
      state.bookedDates = action.payload
    },
    setIsBookingDrawerInfo: (
      state,
      action: PayloadAction<{
        isOpen: boolean
        bookingNumber?: string | null
      }>,
    ) => {
      state.bookingNumber = action.payload.isOpen
        ? action.payload.bookingNumber
        : null
      state.isBookingInfoDrawerOpen = action.payload.isOpen
    },
  },
})

export const {
  setCalendarBlockedDates,
  setCalendarBookedDates,
  setIsBookingDrawerInfo,
} = calendarSlice.actions

export const getCalendarDatesOnly = (state: RootState) =>
  state.calendarReducer?.dates

export const getBlockedDates = (state: RootState) =>
  state.calendarReducer?.blockedDates
export const getBookedDates = (state: RootState) =>
  state.calendarReducer?.bookedDates

export const getIsBookingInfoDrawerOpen = (state: RootState) =>
  state.calendarReducer.isBookingInfoDrawerOpen

export const getBookingNumber = (state: RootState) =>
  state.calendarReducer.bookingNumber

export default calendarSlice.reducer
